import { render, staticRenderFns } from "./DetalhesLogPrecificacao.vue?vue&type=template&id=116a6b82&scoped=true&"
import script from "./DetalhesLogPrecificacao.vue?vue&type=script&lang=ts&"
export * from "./DetalhesLogPrecificacao.vue?vue&type=script&lang=ts&"
import style0 from "./DetalhesLogPrecificacao.vue?vue&type=style&index=0&id=116a6b82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116a6b82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
